<template>
  <div class="upload-box">
    <div>
      <ejs-dropdownlist ref="chooseVers" width="300" class="e-input e-input-group" :dataSource="versionList"
                       :placeholder="$t('DeployManagement.selectProductVersion')"  :index="0" @change="changeVersion"/>
    </div>
    <div class='h100-60 noPage'>
      <ejs-grid ref='grid' height='100%'
                :dataSource="dataList"
                :allowSelection="true"
                :rowSelected="setChildProps"
                :rowDeselected="setChildProps"
                :selectionSettings='selectionOptions'>
        <e-columns>
          <e-column type="checkbox" width="50" textAlign="center"/>
          <e-column field="runState" :headerText="$t('DeployManagement.runStatus')" width='60' textAlign="Center" clipMode='EllipsisWithTooltip'/>
          <e-column field="dname" :headerText="$t('DeployManagement.neName')" width='60' textAlign="Center" clipMode='EllipsisWithTooltip'/>
          <e-column field="version" :headerText="$t('DeployManagement.version')" width='100' textAlign="Center" clipMode='EllipsisWithTooltip'/>
          <e-column field="nodeName" :headerText="$t('DeployManagement.nodeName')" width='100' textAlign="Center" clipMode='EllipsisWithTooltip'/>
          <e-column field="runEnvironment" :headerText="$t('DeployManagement.environmentName')" width='100' textAlign="Center" clipMode='EllipsisWithTooltip'/>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TreeGridPlugin} from '@syncfusion/ej2-vue-treegrid';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import {EventBus} from "../../../../../plugins/eventBus";

Vue.use(TreeGridPlugin, DropDownListPlugin);
export default {
  name: 'UpgradeVersion',
  components: {
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      versionList:[],
      dataMap: new Map(),
      dataList:[],
      envId:'',
      runstateMap: { // 0-2 DP运行状态
        0: this.$t('DeployManagement.unDeploy'),
        1: this.$t('DeployManagement.unRun'),
        2: this.$t('DeployManagement.runing'),
        20: this.$t('DeployManagement.unDeploy'),
        21: this.$t('DeployManagement.unRun'),
        22: this.$t('DeployManagement.runing'),
      },
    };
  },
  methods: {
    changeVersion(){
      const version=this.versionList[this.$refs.chooseVers.ej2Instances.index].value;
      this.dataList =this.dataMap.get(version);
      this.dataList.forEach(item =>{
         let runStateStr = this.runstateMap[item.runState];
         item.runState = runStateStr;
      });
      this.$refs.grid.ej2Instances.dataSource=this.dataList;
    },
    setChildProps() {
      let selectedRecords = this.$refs.grid.ej2Instances.getSelectedRecords();
      let data = {};
      let selected = [];
      data['version'] = this.versionList[this.$refs.chooseVers.ej2Instances.index].value;
      data['envId'] = this.envId;
      const dpIds = [];
      selectedRecords.forEach(e => {
        dpIds.push(e.dpId);
        selected.push({dpId:e.dpId});
      });
      data['ids'] = dpIds;
      EventBus.$emit('selectDpServe', {param:data,records:selected});
    },
    setVersionData(param) {
      this.dataMap = param.data;
      this.envId = param.envId;
      this.versionList = param.versions;
      this.$refs.chooseVers.ej2Instances.dataSource=this.versionList;
    },
  },
  mounted() {
  },
};
</script>
